import { type FC } from "react";

const VoiceModeIcon: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      className="size-6"
    >
      <path
        d="M3 10v4m4.5-3v2M12 6v12m4.5-15v18M21 10v4"
        stroke="currentColor"
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VoiceModeIcon;
